/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarContact_displayInfo = {
    readonly pricing: {
        readonly showSold: boolean | null;
        readonly showUnavailable: boolean | null;
    } | null;
    readonly " $refType": "PdpRespSidebarContact_displayInfo";
};
export type PdpRespSidebarContact_displayInfo$data = PdpRespSidebarContact_displayInfo;
export type PdpRespSidebarContact_displayInfo$key = {
    readonly " $data"?: PdpRespSidebarContact_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_displayInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showUnavailable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f182d826b777d6b4adf124d05d0e1186';
export default node;
